<template>
	<div class="box">
		<section class="header">
			{{ title }}
		</section>
		<!-- <div class="texto" v-html="text"></div> -->
		<div class="mathjax-container">
			<iframe
				:srcdoc="iframeContent"
				height=""
				class="iframe-box"
				frameborder="0"
			>
			</iframe>
		</div>
	</div>
</template>

<script>
// Não remover '\' no fechamento do script
/*eslint-disable */
const script =
	"<script type='text/javascript' id='MathJax-script' async src='https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js'><\/script>";
/*eslint-disable */
const config =
	"<script> MathJax = {tex: { inlineMath: [['$', '$'], ['\\(', '\\)']] }, svg: { fontCache: 'global'}}<\/script>";
export default {
	name: "BoxTitleText",
	props: ["title", "text"],
	data() {
		return {
			iframeContent:
				script +
				config +
				`<div class='mathjax'>${this.text}</div><style> .mathjax{ font-size: 20px;} img {object-fit: contain; width: 100%;}; </style>`
		};
	}
};
</script>

<style lang="scss">
.box {
	margin-top: 10px;
	border: solid 1px $inputs-color;
	color: $font-color;

	.header {
		background-color: $inputs-color;
		display: flex;
		align-items: center;
		height: 40px;
		padding: 0px 10px;
		font-weight: $font-weight-default-bolder;
	}

	.texto {
		background-color: white;
		padding: 10px;
	}

	.mathjax-container {
		display: flex;
		width: 100%;
		justify-content: center;
		align-items: center;
		border: solid 1px #f3f3f3;
	}

	.mathjaxview {
		padding: 8px;
		text-align: left;
		height: 50%;
		width: 100%;
		align-items: center;
		display: inherit;
		gap: 5px;
	}

	img {
		max-width: 100%;
	}
}

.iframe-box {
	display: flex;
	width: 100%;
	height: 300px;
	border: solid 1px #f3f3f3;
}
</style>
